import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import Button from '@sportson/core-web/components/base/Button';
import styled from 'libs/styled';
import PlusIcon from 'assets/media/icons/Plus';
import MinusIcon from 'assets/media/icons/Minus';
import Text from 'components/Text';
import { above } from '@sportson/core-web/utils/mediaqueries';

const Wrapper = styled(Button)`
    display: flex;
    width: 100%;
    padding: ${({ active }) => (active ? '24px 0 40px' : '24px 0')};
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
    z-index: var(--zindex-middleground);
    transition: padding 250ms;

    ${above['tablet.sm']} {
        padding: 24px 0;
    }
`;

const IconWrapper = styled('span')`
    display: flex;
    width: 30px;
    height: 30px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 10px;
    border-radius: 100px;

    transition: background-color 250ms;

    svg {
        transition: transform 250ms;
    }
`;

const AccordionHeader = ({ label, active, onClick }) => {
    const { t } = useTranslation();

    return (
        <Wrapper ariaLabel={t('aria_labels.open_x_accordion', { title: label })} onClick={onClick} active={active}>
            <Text as="h2" typography="UI/20_100_0_450" color="var(--text-color-default)">
                {label}
            </Text>
            <IconWrapper>
                {active ? <MinusIcon color="var(--color-base-black)" /> : <PlusIcon color="var(--color-base-black)" />}
            </IconWrapper>
        </Wrapper>
    );
};

AccordionHeader.propTypes = {
    active: PropTypes.bool,
    label: PropTypes.string.isRequired,
    onclick: PropTypes.func,
    padding: PropTypes.array,
};

AccordionHeader.defaultProps = {
    active: false,
    onclick: () => null,
};

export default AccordionHeader;
